<template>
  <div class="fees-info" :class="{'fees-info--open': isOpen}">
    <div class="fees-info__title" @click="openFeesDetails">
      <span>{{ $t('kano.fee-section.title') }}</span>
      <img
        alt="Arrow Down Icon"
        class="fees-info__icon"
        :src="getStaticAssetUrl(`/resources/icons/arrow-down.svg`)"
        loading="lazy"
      />
    </div>
    <TransitionHeight>
      <ul class="fees-info__list" v-if="isOpen">
        <li class="fees-info__item">
          <span class="fees-info__label">{{ $t('kano.fee-section.service-fee') }}</span>
          <span>{{ getFees('service') }}</span>
        </li>
        <li class="fees-info__item">
          <span class="fees-info__label">{{ $t('kano.fee-section.network-fee') }}</span>
          <span>{{ getFees('network') }}</span>
        </li>
        <li class="fees-info__item">
          <span class="fees-info__label">{{ $t('kano.fee-section.total-fee') }}</span>
          <span>{{ getFees('total') }}</span>
        </li>
      </ul>
    </TransitionHeight>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { getStaticAssetUrl } from '@/helpers/cdnHelper';
import { DEFAULT_CURRENCY_FROM } from '@/constants/exchange-form';
import { ExchangeCommission } from "@kano/types";
import TransitionHeight from '@kano/components/TransitionHeight.vue';

const props = defineProps<{
  fees: ExchangeCommission
}>();

const isOpen = ref(false);

const getFees = (name: string) => {
  if (!props.fees) {
    return `0 ${ DEFAULT_CURRENCY_FROM }`;
  }

  return `${ props.fees[name].amount } ${ props.fees[name].currencyCode }`;
};

const openFeesDetails = () => {
  isOpen.value = !isOpen.value;
};

</script>
<style lang="scss" scoped></style>